import { Model, Query } from "@nozbe/watermelondb";
import { useState, useCallback } from "react";

export const useOfflineQuery = <T extends Model>() => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<T[]>([]);

  const doQuery = useCallback(async (qb: Query<T>) => {
    setLoading(true);
    return qb
      .fetch()
      .then((res) => {
        setData(res);
        return res;
      })
      .finally(() => setLoading(false));
  }, []);

  return {
    data,
    loading,
    doQuery,
  };
};
